import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const STR = {
  en: {
    app_name: "Qatar AI Governance Lifecycle Sandbox",
    subtitle: "AI GOVERNANCE • SECURITY • RISK • COMPLIANCE • RED TEAM • ASSURANCE",
    company: "ITOO TECHNOLOGIES W.L.L.",
    env: "DEVELOPMENT SANDBOX – SYNTHETIC DATA",
    banner: "DEVELOPMENT SANDBOX – ALL DATA, VOICE RESPONSES, RED TEAM RESULTS AND ACTIONS ARE SYNTHETIC. REGULATORY MAPPINGS ARE ADVISORY, NOT LEGAL ADVICE. NO REAL SYSTEMS ARE MODIFIED.",
    login: "Sign In", email: "Email", password: "Password", logout: "Logout",
    signing_in: "Signing in...", welcome: "Welcome back", login_sub: "Enterprise AI Governance Operating System",
    search: "Search...", search_global: "Global search across use cases, risks, red team, regulations...",
    total_usecases: "Total AI Use Cases", industries: "Industries", regulatory_codes: "Regulatory Codes",
    ai_models: "AI Models", redteam_tests: "Red Team Tests", open_critical_risks: "Open Critical Risks",
    open_high_risks: "Open High Risks", open_redteam: "Open Red Team Findings", pending_approvals: "Pending Approvals",
    compliance_gaps: "Compliance Gaps", overdue_remediations: "Overdue Remediations", ai_cost: "AI Cost",
    ai_value: "AI Value", ai_readiness: "AI Readiness", governance_maturity: "Governance Maturity",
    lifecycle_dist: "Use Cases by Lifecycle Stage", industry_dist: "Industry Distribution",
    risk_dist: "Risk Distribution", run_demo: "Run Sandbox Demo", run_redteam: "Run Red Team Test",
    view_details: "View Details", back: "Back", simulated: "SIMULATED RESULT – SANDBOX MODE",
    security_gate: "Security Gate", blocked: "BLOCKED", passed: "PASSED", retest: "Retest",
    add_usecase: "Add Use Case", add_integration: "Add Integration", auto_fix: "AI Assist / Auto-Fix",
    voice_assistant: "Voice Assistant", ask: "Ask", listening: "Listening...", read_aloud: "Read Aloud",
    all: "All", filter: "Filter", role: "Role", status: "Status", severity: "Severity", owner: "Owner",
    industry: "Industry", risk: "Risk", lifecycle: "Lifecycle", name: "Name", actions: "Actions",
    create: "Create", cancel: "Cancel", save: "Save", apply_fix: "Apply Fix", scan: "Scan",
    nav: {
      dashboard: "Executive Dashboard", portfolio: "AI Portfolio", usecases: "Use Cases",
      lifecycle: "Governance Lifecycle", regulatory: "Qatar Regulatory Engine", risk: "Risk Management",
      data: "Data Governance", security: "AI Security", redteam: "AI Red Team", models: "Model Governance",
      agents: "Agent Governance", policies: "Policies", controls: "Controls", compliance: "Compliance & GRC",
      audit: "Audit Center", monitoring: "Continuous Monitoring", kpi: "KPI / KRI / KCI", value: "AI Value",
      voice: "Voice Assistant", simulator: "Sandbox Simulator", users: "User & Group Management",
      integrations: "Integrations", admin: "System Administration", autofix: "AI Auto-Fix", rag: "RAG Governance",
      pum: "Portal User Manager",
    },
  },
  ar: {
    app_name: "بيئة حوكمة دورة حياة الذكاء الاصطناعي في قطر",
    subtitle: "الحوكمة • الأمن • المخاطر • الامتثال • الفريق الأحمر • الضمان",
    company: "شركة إيتو للتكنولوجيا ذ.م.م",
    env: "بيئة تطوير تجريبية – بيانات اصطناعية",
    banner: "بيئة تطوير تجريبية – جميع البيانات والردود الصوتية ونتائج الفريق الأحمر والإجراءات اصطناعية. التعيينات التنظيمية استشارية وليست مشورة قانونية. لا يتم تعديل أي أنظمة حقيقية.",
    login: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور", logout: "تسجيل الخروج",
    signing_in: "جارٍ تسجيل الدخول...", welcome: "مرحباً بعودتك", login_sub: "نظام تشغيل حوكمة الذكاء الاصطناعي المؤسسي",
    search: "بحث...", search_global: "بحث شامل في حالات الاستخدام والمخاطر والفريق الأحمر واللوائح...",
    total_usecases: "إجمالي حالات الاستخدام", industries: "القطاعات", regulatory_codes: "الرموز التنظيمية",
    ai_models: "نماذج الذكاء الاصطناعي", redteam_tests: "اختبارات الفريق الأحمر", open_critical_risks: "مخاطر حرجة مفتوحة",
    open_high_risks: "مخاطر عالية مفتوحة", open_redteam: "نتائج الفريق الأحمر المفتوحة", pending_approvals: "موافقات معلقة",
    compliance_gaps: "فجوات الامتثال", overdue_remediations: "معالجات متأخرة", ai_cost: "تكلفة الذكاء الاصطناعي",
    ai_value: "قيمة الذكاء الاصطناعي", ai_readiness: "جاهزية الذكاء الاصطناعي", governance_maturity: "نضج الحوكمة",
    lifecycle_dist: "حالات الاستخدام حسب مرحلة دورة الحياة", industry_dist: "توزيع القطاعات",
    risk_dist: "توزيع المخاطر", run_demo: "تشغيل العرض التجريبي", run_redteam: "تشغيل اختبار الفريق الأحمر",
    view_details: "عرض التفاصيل", back: "رجوع", simulated: "نتيجة محاكاة – الوضع التجريبي",
    security_gate: "بوابة الأمن", blocked: "محظور", passed: "ناجح", retest: "إعادة الاختبار",
    add_usecase: "إضافة حالة استخدام", add_integration: "إضافة تكامل", auto_fix: "المساعد الذكي / الإصلاح التلقائي",
    voice_assistant: "المساعد الصوتي", ask: "اسأل", listening: "جارٍ الاستماع...", read_aloud: "قراءة بصوت عالٍ",
    all: "الكل", filter: "تصفية", role: "الدور", status: "الحالة", severity: "الخطورة", owner: "المالك",
    industry: "القطاع", risk: "المخاطر", lifecycle: "دورة الحياة", name: "الاسم", actions: "إجراءات",
    create: "إنشاء", cancel: "إلغاء", save: "حفظ", apply_fix: "تطبيق الإصلاح", scan: "فحص",
    nav: {
      dashboard: "لوحة التحكم التنفيذية", portfolio: "محفظة الذكاء الاصطناعي", usecases: "حالات الاستخدام",
      lifecycle: "دورة حياة الحوكمة", regulatory: "المحرك التنظيمي القطري", risk: "إدارة المخاطر",
      data: "حوكمة البيانات", security: "أمن الذكاء الاصطناعي", redteam: "الفريق الأحمر", models: "حوكمة النماذج",
      agents: "حوكمة الوكلاء", policies: "السياسات", controls: "الضوابط", compliance: "الامتثال والحوكمة",
      audit: "مركز التدقيق", monitoring: "المراقبة المستمرة", kpi: "المؤشرات", value: "القيمة",
      voice: "المساعد الصوتي", simulator: "المحاكي التجريبي", users: "إدارة المستخدمين والمجموعات",
      integrations: "التكاملات", admin: "إدارة النظام", autofix: "الإصلاح التلقائي", rag: "حوكمة RAG",
      pum: "مدير مستخدمي البوابة",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("qaig_lang") || "en");
  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("qaig_lang", lang);
  }, [lang]);
  const t = useCallback((key) => {
    const parts = key.split(".");
    let v = STR[lang];
    for (const p of parts) v = v?.[p];
    return v || key;
  }, [lang]);
  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));
  return <I18nContext.Provider value={{ lang, setLang, toggle, t, rtl: lang === "ar" }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
